import { ModuleRequestError } from '@wit-support/admin-client-core';
import { describeCampaignsError } from '../errors.js';
const KIND_BY_CODE = {
    'stale-preview': 'stale',
    'preview-mismatch': 'mismatch',
    'change-in-progress': 'in-progress',
    'idempotency-in-progress': 'in-progress',
    'launch-not-started': 'launch-not-started',
    BUDGET_THROTTLED: 'throttled',
    'outcome-unknown': 'unknown-outcome',
    'meta-error': 'meta',
    'meta-validation-failed': 'meta',
    'ack-required': 'ack',
    'preview-expired': 'expired',
    'preview-required': 'expired',
    'agent-limit-exceeded': 'agent-limit',
    'geo-non-country-present': 'geo-blocked',
    'advantage-state-unknown': 'advantage-unknown',
    'interests-multi-group': 'interests-multi',
    'object-archived': 'archived',
    'invalid-values': 'invalid',
};
const FALLBACK = {
    stale: 'Настройки изменились в Meta, пока вы редактировали. Ничего не применено.',
    mismatch: 'Запрос не совпал с просмотренным — проверьте изменения заново.',
    'in-progress': 'Эта кампания уже меняется, подождите минуту.',
    expired: 'Просмотр устарел — проверьте изменения заново. Ничего не применено.',
    'unknown-outcome': 'Не знаем, применилась ли правка. Перечитайте настройки из Meta.',
};
const issuesOf = (err) => err.issues.flatMap((i) => {
    if (i === null || typeof i !== 'object')
        return [];
    const r = i;
    return typeof r['message'] === 'string' && r['message'] !== ''
        ? [
            {
                fieldKey: typeof r['fieldKey'] === 'string' ? r['fieldKey'] : null,
                message: r['message'],
            },
        ]
        : [];
});
/** Ошибку правки — в понятный вид: класс состояния + фраза + замечания к полям. */
export function classifyLiveError(err) {
    if (!(err instanceof ModuleRequestError)) {
        return { kind: 'other', text: describeCampaignsError(err, 'write'), issues: [] };
    }
    const kind = (err.upstreamCode !== null ? KIND_BY_CODE[err.upstreamCode] : undefined) ?? 'other';
    const text = err.serverMessage ?? FALLBACK[kind] ?? describeCampaignsError(err, 'write');
    // причина отказа Meta — по-русски от сервера; настоящий текст Meta (userMsg) добавляем, если его там нет
    const meta = err.details['metaError'];
    const userMsg = meta !== null && typeof meta === 'object' ? meta['userMsg'] : null;
    const withMeta = kind === 'meta' && typeof userMsg === 'string' && userMsg !== '' && !text.includes(userMsg)
        ? `${text} ${userMsg}`
        : text;
    const out = { kind, text: withMeta, issues: issuesOf(err) };
    if (kind === 'launch-not-started') {
        const d = err.details;
        const launchId = d['launchId'];
        if (typeof launchId === 'string' && launchId !== '') {
            out.launch = {
                launchId,
                startsAt: typeof d['startsAt'] === 'string' ? d['startsAt'] : null,
                availableActions: Array.isArray(d['availableActions'])
                    ? d['availableActions'].filter((a) => typeof a === 'string')
                    : [],
            };
        }
    }
    return out;
}
/** После этих отказов «Применить» не работает: нужен новый предпросмотр (кнопка «Назад» → «Проверить»). */
export const NEEDS_NEW_PREVIEW = [
    'stale',
    'mismatch',
    'unknown-outcome',
    'expired',
];
/** Действия запуска словами (то, что запуск предлагает вместо правки). */
export const LAUNCH_ACTION_RU = {
    activate: 'включить запуск',
    pause: 'поставить на паузу',
    rollback: 'откатить',
    retry: 'повторить',
    reverify: 'перепроверить',
    cancel: 'отменить',
    edit: 'изменить запуск',
};
//# sourceMappingURL=live-error.js.map